import React, { useState } from 'react';
import { Popin } from '../../type';
import styles from '../../product-timeline.module.scss';
import ActionView from './action';
import { Order } from '../../interfaces/myOrder';
import { Product } from '../../interfaces/orderSaleProduct';
import { ActionIdentifier, TimelineAnalyticsTracking, TimelineStep } from '../../interfaces/timeline';
import PopinView from '../../popin';

const ActionsView: React.FC<{
  product: Product;
  order: Order | null;
  step: TimelineStep;
  analyticsTracking: TimelineAnalyticsTracking;
}> = ({ product, order, step, analyticsTracking }) => {
  const [popin, updatePopin] = useState<Popin | null>(null);
  const { actions } = step;
  if (actions == null) {
    return <></>;
  }

  const actionsChronology = actions.actionsChronology;

  const actionList = Array.isArray(actionsChronology)
    ? actionsChronology
        .map((key) => {
          // eslint-disable-next-line no-restricted-syntax
          const parsedKey = key as ActionIdentifier;

          const action = actions[parsedKey];
          if (!action || Array.isArray(action)) {
            return null;
          }
          if (
            // Pay for type safe
            parsedKey === 'cancel' ||
            parsedKey === 'confirmDelivery' ||
            parsedKey === 'contact' ||
            parsedKey === 'download' ||
            parsedKey === 'qualityControlReport' ||
            parsedKey === 'relist' ||
            parsedKey === 'report' ||
            parsedKey === 'returnForm' ||
            parsedKey === 'withdrawReturn' ||
            parsedKey === 'getPaid' ||
            parsedKey === 'shippingLabel' ||
            parsedKey === 'uploadInvoice' ||
            parsedKey === 'updateAddress' ||
            parsedKey === 'editShippingDetails' ||
            key === 'accept'
          ) {
            action.identifier = parsedKey;
          }
          return action;
        })
        .filter((action) => action != null)
    : [];

  if (actionList.length === 0) return <></>;

  return (
    <div className={styles.ordersSales__mainRight__steps__step__box__actions}>
      {actionList.map((action) => {
        return (
          <ActionView
            key={action.identifier}
            updatePopin={updatePopin}
            order={order}
            product={product}
            step={step}
            action={action}
            analyticsTracking={analyticsTracking}
          />
        );
      })}
      <PopinView
        popin={popin}
        closePopin={() => updatePopin(null)}
      />
    </div>
  );
};

export default ActionsView;
